exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.trip_datetime[data-v-f775306c] {\r\n    margin-top: 0;\r\n    margin-bottom: 0;\n}\n@media only screen and (min-width: 768px) {\n.trip_datetime[data-v-f775306c] {\r\n        margin-top: 1rem;\r\n        margin-bottom: 1.5rem;\n}\n.trip_date_right[data-v-f775306c] {\r\n        float: none;\r\n        padding-right: 0;\n}\n.trip_date_date_month[data-v-f775306c] {\r\n        padding-left: 0.4em;\n}\n}\n[data-v-f775306c] .weekly-schedule-wrapper {\r\n    display: inline-block;\n}\r\n", ""]);

// exports
